import fetch from '@/utils/fetch'


export const getGoodsCouponList = (body: any = {}, headers: any = {}) =>
  fetch.post({
    url: '/api/v1/h5/adapter/frontconfig/goodsCouponList',
    data: body,
    headers,
  })
